module.exports = __webpack_public_path__ + "fonts/poppins-v15-latin-500.cb0ab582.woff";